var _path, _path2, _path3, _path4, _path5, _linearGradient, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2491,
    height: 2500,
    viewBox: "0 0 435.816 437.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.341.039s128.478-5.783 196.57 123.337H206.416s-39.188-1.289-72.593 46.255c-9.634 19.916-19.91 40.473-8.349 80.937C108.773 222.309 36.823 97.04 36.823 97.04S87.578 5.176 217.341.039z",
    fill: "#c6352e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M407.223 327.871s-59.247 114.143-205.118 108.533c17.995-31.148 103.772-179.682 103.772-179.682s20.709-33.289-3.744-85.991c-12.431-18.305-25.09-37.486-65.919-47.713 32.836-.326 177.285.021 177.285.021s54.168 89.891-6.276 204.832z",
    fill: "#f4d911"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.373 328.738s-69.224-108.395 8.58-231.908c17.979 31.16 103.71 179.72 103.71 179.72s18.469 34.578 76.341 39.756c22.061-1.609 45.007-2.982 74.279-33.223-16.139 28.594-88.673 153.521-88.673 153.521S97.681 438.56 28.373 328.738z",
    fill: "#81b354"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.105 437.46l29.187-121.793s32.092-2.504 58.982-32.017c-16.693 29.365-88.169 153.81-88.169 153.81z",
    fill: "#7baa50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.59 220.093c0-53.69 43.52-97.215 97.215-97.215 53.69 0 97.214 43.524 97.214 97.215 0 53.693-43.522 97.219-97.214 97.219-53.695 0-97.215-43.525-97.215-97.219z",
    fill: "#fff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -829.128,
    y1: 1417.339,
    x2: -829.128,
    y2: 1261.441,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1557.636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2c0e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406cb1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.86 220.093c0-44.702 36.238-80.941 80.945-80.941 44.698 0 80.94 36.239 80.94 80.941 0 44.703-36.242 80.945-80.94 80.945-44.707.001-80.945-36.244-80.945-80.945z",
    fill: "url(#a)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M413.5 123.039l-120.183 35.237s-18.123-26.596-57.104-35.258c33.776-.115 177.287.021 177.287.021z",
    fill: "#e7ce12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.137 246.197c-16.89-29.25-86.31-149.16-86.31-149.16l89.029 88.07s-9.149 18.82-5.68 45.7l2.961 15.39z",
    fill: "#bc332c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.fa67a97c5991c1ea09ab5c75932e1268.svg";
export { ForwardRef as ReactComponent };